import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";

export default function useRemoveConversation() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [removeLoading, setRemoveLoading] = useState(false);

  function removeConversation(key, onSuccess) {
    fetchWrapper({
      endpoint_url: "conversation/removeConversation",
      setLoading: setRemoveLoading,
      params: {
        key: key,
      },
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          showMessage({ type: "success", message: fetch_output.message });
          onSuccess(key);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "remove conversation" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "remove conversation" });
      },
    });
  }

  return { removeConversation, removeLoading };
}
